/**
 * Satıcının girdiği tutarı (seçili para birimi) API'de saklanan USD fiyatına çevirir.
 * ratesFromTry: 1 TRY karşılığında kaç birim (CurrencyProvider ile aynı).
 */
export function convertEnteredPriceToUsd(amount, currency, ratesFromTry) {
  const value = parseFloat(amount);
  if (!Number.isFinite(value) || value <= 0) return 0;
  const rates = { TRY: 1, ...(ratesFromTry || {}) };
  const code = currency || 'TRY';
  const rate = rates[code];
  const tryAmount = code === 'TRY' ? value : value / (rate || 1);
  return tryAmount * (rates.USD ?? 0.029);
}

export function foldCategoryText(value) {
  return (value || '')
    .toLocaleLowerCase('tr-TR')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/ı/g, 'i')
    .replace(/\s+/g, ' ')
    .trim();
}

/** AI veya metin ipuçlarından kategori id (yaprak tercih). */
export function pickCategoryIdFromHints(data, options) {
  if (!Array.isArray(options) || !options.length) return '';
  const direct = data?.subcategory_id || data?.category_id;
  if (direct) return String(direct);

  const hints = [data?.subcategory, data?.category, data?.estimated_product_type, data?.product_name].filter(
    (item) => typeof item === 'string' && item.trim(),
  );
  if (!hints.length) return '';

  let best = null;
  let bestScore = 0;
  for (const cat of options) {
    const hay = foldCategoryText(`${cat.name || ''} ${cat.slug || ''}`.replace(/-/g, ' '));
    if (!hay) continue;
    let score = 0;
    for (const raw of hints) {
      const label = foldCategoryText(raw);
      const name = foldCategoryText(cat.name || '');
      if (!label) continue;
      if (name === label || hay === label) score += 120;
      else if (label.includes(hay) || hay.includes(label) || name.includes(label) || label.includes(name)) {
        score += Math.max(label.length, name.length, 6);
      } else {
        label.split(' ').forEach((token) => {
          if (token.length >= 3 && hay.includes(token)) score += token.length * 2;
        });
      }
    }
    if (score > bestScore) {
      bestScore = score;
      best = cat;
    }
  }
  if (!best || bestScore < 4) return '';

  const children = options.filter((row) => String(row.parent_id || '') === String(best.id));
  if (!children.length) return String(best.id);

  let childBest = null;
  let childScore = 0;
  for (const cat of children) {
    const hay = foldCategoryText(`${cat.name || ''} ${cat.slug || ''}`.replace(/-/g, ' '));
    let score = 0;
    for (const raw of hints) {
      const label = foldCategoryText(raw);
      if (label && (hay.includes(label) || label.includes(hay))) score += label.length;
    }
    if (score > childScore) {
      childScore = score;
      childBest = cat;
    }
  }
  return String((childScore >= 3 ? childBest : best).id);
}
